const SpecificationsTable = ({ data = {} }: { data?: Record<string, any> }) => {
  const entries = Object.entries(data);

  if (!entries.length) return null;

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr>
            <th className="text-left py-3 px-4 font-semibold text-[#2d2c2c] w-1/2 border-b border-gray-200">
              Название
            </th>
            <th className="text-left py-3 px-4 font-semibold text-[#2d2c2c] w-1/2 border-b border-gray-200">
              Значение
            </th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([label, value], i) => (
            <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              <td className="py-3 px-4 text-gray-700 border-b border-gray-100">{label}</td>
              <td className="py-3 px-4 text-gray-700 border-b border-gray-100">{String(value)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SpecificationsTable;
